import { gsap } from 'gsap';
import HomeHeroBearVideo from './HomeHeroBearVideo';
import '@lottiefiles/lottie-player';

export default class HomeHero {
	constructor(elm) {
		this.elm = elm;

		this.menu = document.querySelector('[data-menu]');

		this.bearVideoElm = this.elm.querySelector('[data-home-hero-bear]');
		this.bearVideo = new HomeHeroBearVideo(this.bearVideoElm, this);

		this.bg = this.elm.querySelector('[data-home-hero-bg]');
		this.gradient = this.elm.querySelector('[data-home-hero-gradient-wrapper]');

		this.moodIndex = 0;
		this.moods = ['#6accff', '#a487fb', '#ff69c4', '#ffa53c', '#32d16f'];

		this.heading = this.elm.querySelector('[data-home-hero-heading]');
		this.marks = this.heading.querySelectorAll('mark');

		this.buttons = this.elm.querySelectorAll('[data-home-hero-button]');

		this.buttons.forEach((button) => {
			button.addEventListener('mouseenter', () => {
				const doodle = button.querySelector('[data-home-hero-doodle]');
				doodle.seek(0);
				doodle.setSpeed(2);
				doodle.play();
			});
		});

		this.breathingDoodle1 = this.elm.querySelector('[data-home-hero-breathing-doodle="curl-03"]');
		this.breathingDoodle2 = this.elm.querySelector('[data-home-hero-breathing-doodle="curl-04"]');
		this.breathingDoodle3 = this.elm.querySelector('[data-home-hero-breathing-doodle="swoosh-02"]');

		this.phone = this.elm.querySelector('[data-home-hero-phone]');

		this.nextModule = this.elm.closest('main').querySelector('[data-m-text-columns]');

		this.isReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		this.setInitialValues();
	}

	setInitialValues() {
		gsap.set(this.bg, {
			background: this.moods[this.moodIndex],
			autoAlpha: 0,
		});
		this.moodIndex++;

		gsap.set(this.gradient, {
			autoAlpha: 0.5,
		});

		gsap.set(this.heading, {
			color: 'transparent',
			autoAlpha: 1,
			scale: 0.75,
		});

		gsap.set(this.buttons, {
			autoAlpha: 0,
			scale: 0.5,
		});

		gsap.set(this.phone, {
			autoAlpha: 0,
			xPercent: 200,

			scale: 0.75,
			transform: 'rotate3d(0, 0, 0, 0deg)',
		});

		gsap.set(this.nextModule, {
			autoAlpha: 0,
		});
	}

	skipIntroAnimation() {
		this.introAnimationIn(true);
		this.introAnimationOut(true);
		this.bearVideo.skipIntro();
	}

	startIntroAnimation() {
		this.bearVideo.startIntro();
	}

	introAnimationIn(instant) {
		if (!window.menuInteractive) {
			gsap.to(this.menu, {
				autoAlpha: 1,
				scale: 1,
				clearProps: 'all',
				ease: 'power3.inOut',
				duration: instant ? 0 : 3,
				onComplete: () => {
					window.menuInteractive = true;
				},
			});
		}

		gsap.to(this.bg, {
			autoAlpha: 1,
			ease: 'power3.inOut',
			duration: instant ? 0 : 3,
		});

		gsap.to(this.heading, {
			color: 'black',
			scale: 1,
			ease: 'power3.inOut',
			duration: instant ? 0 : 3,
		});

		setTimeout(
			() => {
				this.showMarkers();
			},
			instant ? 0 : 1400
		);

		gsap.to(this.phone, {
			xPercent: 0,
			scale: 1,
			autoAlpha: 1,
			// transform: 'rotate3d(1, -2, 2, 15deg)',
			ease: 'elastic.inOut(1.2,1)',
			duration: instant ? 0 : 8,
		});

		if (this.isReduceMotion) {
			this.goToLastFrame(this.breathingDoodle3);
		} else {
			setTimeout(
				() => {
					this.breathingDoodle3.play();
				},
				instant ? 0 : 5000
			);
		}
	}

	introAnimationOut(instant) {
		gsap.to(this.gradient, {
			autoAlpha: 1,

			ease: 'power3.inOut',
			duration: instant ? 0 : 3,
		});

		gsap.to(this.buttons, {
			autoAlpha: 1,
			scale: 1,

			ease: 'power2.inOut',
			duration: instant ? 0 : 1,
			delay: instant ? 0 : 0.5,
			stagger: instant ? 0 : 0.5,
		});

		if (this.isReduceMotion) {
			this.buttons.forEach((button) => {
				const doodle = button.querySelector('[data-home-hero-doodle]');
				this.goToLastFrame(doodle);
			});
		} else {
			setTimeout(
				() => {
					this.buttons.forEach((button) => {
						const doodle = button.querySelector('[data-home-hero-doodle]');
						if (doodle) {
							doodle.play();
						}
					});
				},
				instant ? 0 : 800
			);
		}

		gsap.to(this.nextModule, {
			autoAlpha: 1,

			ease: 'power3.inOut',
			duration: instant ? 0 : 3,
		});

		if (this.isReduceMotion) {
			this.goToLastFrame(this.breathingDoodle1);
			this.goToLastFrame(this.breathingDoodle2);
		} else {
			setTimeout(
				() => {
					this.breathingDoodle1.play();

					this.breathingDoodle2.play();
				},
				instant ? 0 : 3000
			);
		}
	}

	breathIn() {
		gsap.to(this.bg, {
			background: this.moods[this.moodIndex],
			duration: 3,
			ease: 'power2.inOut',
			onComplete: () => {
				if (this.moodIndex >= this.moods.length) {
					this.moodIndex = 0;
				} else {
					this.moodIndex++;
				}
			},
		});

		gsap.to(this.phone, {
			yPercent: -2,

			duration: 3,
			ease: 'power2.inOut',
		});

		gsap.to(this.gradient, {
			autoAlpha: 0.5,

			duration: 3,
			ease: 'power2.inOut',
			onComplete: () => {
				this.breathOut();
			},
		});
	}

	breathOut() {
		gsap.to(this.phone, {
			yPercent: 0,

			duration: 3,
			ease: 'power2.inOut',
		});

		gsap.to(this.gradient, {
			autoAlpha: 1,

			duration: 3,
			ease: 'power2.inOut',
		});
	}

	showMarkers() {
		this.marks.forEach((mark) => {
			mark.classList.add('is-visible');
		});
	}

	goToLastFrame(animation) {
		if (animation) {
			const lottieInstance = animation.getLottie();
			if (lottieInstance.isLoaded) {
				const lastFrame = lottieInstance.totalFrames;
				lottieInstance.goToAndStop(lastFrame - 1, true);
			} else {
				lottieInstance.addEventListener('DOMLoaded', () => {
					const lastFrame = lottieInstance.totalFrames;
					lottieInstance.goToAndStop(lastFrame - 1, true);
				});
			}
		}
	}
}
